module.exports = __webpack_public_path__ + "img/19.6069e01f.jpeg";